module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "Ak-min.37f36a80.jpg";